module.exports = __webpack_public_path__ + "images/emoji/tulip.6192ef8bf9b11ec19d28.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tulip.png
// module id = BazD
// module chunks = 24